import { useFundStore } from '@/stores/fund'
import { InvestmentsApi } from "@/api/investment_api"
import { FinancialDataApi, eavField } from "@/api/financial_data_api"

export default {
	async clearCache() {
		return useFundStore().reloadFunds()
	},

	async loadFundPerformance() {
		console.log(`loading fund performance`)
		const funds = await this.loadFunds()

		const performances = await Promise.all(funds.map(async fund => {
			const records = await FinancialDataApi.getFundFinancialsByType(fund.guid, 'fund_performance')
			return {
				name:      fund.name,
				fundId:    fund.guid,
				grossIRR:  eavField(records, 'gross_irr'),
				netIRR:    eavField(records, 'net_irr'),
				grossMOIC: eavField(records, 'gross_moic'),
				netMOIC:   eavField(records, 'net_moic')
			}
		}))

		performances.sort((a, b) => {
			const fundA = funds.find(f => f.name === a.name)
			const fundB = funds.find(f => f.name === b.name)
			return Number(fundA?.displayOrder) > Number(fundB?.displayOrder) ? 1 : -1
		})

		return performances
	},

	async loadEbitda() {
		console.log(`loadEbitda`)
		const funds = await this.loadFunds()
		return InvestmentsApi.getPerformance().then((performanceData) => {
			const rtn = { investments: [] }
			for (const fund of funds) {
				const fundId = fund.guid
				for (const investmentData of performanceData) {
					if (investmentData.fundIds?.includes(fundId) && (investmentData.ebitdaAtEntry != null || investmentData.ebitdaLatest != null)) {
						rtn.investments.push({
							companyId:      investmentData.guid,
							name:           investmentData.name,
							entry_ebitda:   Number((investmentData.ebitdaAtEntry ?? 0) / 1000000),
							current_ebitda: Number((investmentData.ebitdaLatest ?? 0) / 1000000),
							fund:           fund.name,
							fundId:         fundId
						})
					}
				}
			}
			return rtn
		})
	},

	async loadValueStatus() {
		console.log(`loadValueStatus`)
		const funds = await this.loadFunds()

		const rtn = { fundData: {} }
		await Promise.all(funds.map(async fund => {
			const records = await FinancialDataApi.getFundFinancialsByType(fund.guid, 'fund_equity_value')
			rtn.fundData[fund.guid] = {
				realizedAmt:   eavField(records, 'bertram_realized_equity_value'),
				unrealizedAmt: eavField(records, 'bertram_unrealized_fmv_equity_value')
			}
		}))

		return rtn
	},

	async loadFundsData() {
		console.log('loadFundsData')
		const funds = await this.loadFunds()

		const fundsData = await Promise.all(funds.map(async fund => {
			const records = await FinancialDataApi.getFundFinancialsByType(fund.guid, 'fund_funds_data')
			const asOf = records?.[0]?.fields?.find(f => f.fieldName === 'as_of')?.value ?? records?.[0]?.dateCreated ?? null
			return {
				id:           fund.name,
				name:         fund.name,
				asOf:         asOf,
				amtInvested:  eavField(records, 'invested'),
				amtFees:      eavField(records, 'fees'),
				amtExpenses:  eavField(records, 'expenses'),
				amtAvailable: eavField(records, 'available')
			}
		}))

		fundsData.sort((a, b) => {
			const fundA = funds.find(f => f.name === a.name)
			const fundB = funds.find(f => f.name === b.name)
			return Number(fundA?.displayOrder) < Number(fundB?.displayOrder) ? 1 : -1
		})

		return fundsData
	},

	async loadFunds() {
		const store = useFundStore()
		if (!store.funds.length) {
			await store.initializeFunds()
		}
		return store.funds
	}
}
